import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { Checkbox } from '@components/ui/checkbox';
import { FormField } from '@components/ui/form';
import { TapTip } from '@components/schedules/dialogs/external/mobile/tapTip';
import { RelatedConfirmedProps } from './types';

export const RelatedConfirmed = ({ id, disabled }: RelatedConfirmedProps) => {
  const { t } = useTranslation('app');
  const { control } = useFormContext<{ confirmed: boolean }>();

  return (
    <FormField
      control={control}
      name="confirmed"
      render={({ field: { value, onChange, ...rest } }) => (
        <div className="flex flex-wrap items-center gap-x-1 gap-y-1.5">
          <Checkbox
            {...rest}
            id={`related-confirmed-${id}`}
            className="h-6 w-6"
            disabled={disabled}
            checked={Boolean(value)}
            onCheckedChange={onChange}>
            {t('forms.confirmed.label')}
          </Checkbox>
          <TapTip label={t('forms.confirmed.label')}>{t('schedules.confirmedTooltip')}</TapTip>
        </div>
      )}
    />
  );
};
